<template>
  <div>
    <section class="hero has-shadow is-grey-ligth">
      <div class="hero-head" style="margin-bottom: 20px;">
        <br />
        <div
          class="container is-flex is-justify-between"
          style="align-items: center; margin: 0px 25px 0 13px;"
        >
          <h1
            class="title has-text-weight-bold has-text-dark is-2"
            style="margin-bottom: 0; text-wrap: nowrap;"
          >
            Líderes PHD
          </h1>
          <div
            v-if="tokenUser && tokenUser.admin"
            class="text-card"
            v-tooltip.bottom="{
              content: empresa.nombre,
              trigger: isMovil ? 'click' : 'manual',
            }"
          >
            <span class="is-size-6 w-full truncate">{{ empresa.nombre }}</span>
            <p
              v-if="proceso.nombre !== '.....'"
              class="is-size-5 has-text-weight-bold truncate"
            >
              {{ proceso.nombre }}
            </p>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <!-- Menu -->
        <nav class="tabs is-boxed">
          <div class="container">
            <ul v-if="!isMovil">
              <li
                v-bind:class="{ 'is-active': activo('yProceso') }"
                @click="selectSection({ d: 'yProceso', name: 'Proceso' })"
              >
                <a href="#">Proceso</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yEmpleados') }"
                @click="selectSection({ d: 'yEmpleados', name: 'Empleados' })"
              >
                <a href="#">Empleados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yAjustes') }"
                v-if="tokenUser ? tokenUser['admin'] : false"
                @click="selectSection({ d: 'yAjustes', name: 'Configuración' })"
              >
                <a href="#">Configuración</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yRelaciones') }"
                @click="selectSection({ d: 'yRelaciones', name: 'Relaciones' })"
              >
                <a href="#">Relaciones</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yResumen') }"
                @click="selectSection({ d: 'yResumen', name: 'Resumen' })"
              >
                <a>Resumen</a>
              </li>
              <li
                v-bind:class="{
                  'is-active': activo('yResultado') || activo('yGuide'),
                }"
                @click="selectSection({ d: 'yGuide', name: 'Guia' })"
              >
                <a href="#">Resultados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yFiles') }"
                @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
              >
                <a href="#">Anexos</a>
              </li>
            </ul>
            <ul v-if="isMovil">
              <li
                class="is-active"
                v-on:click="showMenuMobile = !showMenuMobile"
              >
                <a href="javascript:void(0)" class="is-flex">
                  {{ title }}
                  <span class="icon is-small">
                    <i class="material-icons">expand_more</i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <div
      style="display: flex;
      justify-content: left;
      margin-left: 40px;
      text-align: center;"
    >
      <!-- Mobile -->
      <div
        v-if="isMovil"
        class="dropdown"
        :class="showMenuMobile ? 'is-active' : ''"
      >
        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yProceso') }"
              @click="selectSection({ d: 'yProceso', name: 'Proceso' })"
            >
              Proceso
            </a>
            <a
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yEmpleados') }"
              @click="selectSection({ d: 'yEmpleados', name: 'Empleados' })"
            >
              Empleados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yAjustes') }"
              v-if="tokenUser ? tokenUser['admin'] : false"
              @click="selectSection({ d: 'yAjustes', name: 'Configuración' })"
            >
              Ajustes
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yRelaciones') }"
              @click="selectSection({ d: 'yRelaciones', name: 'Relaciones' })"
            >
              Relaciones
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yResumen') }"
              @click="selectSection({ d: 'yResumen', name: 'Resumen' })"
            >
              Resumen
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{
                'is-active': activo('yResultado') || activo('yGuide'),
              }"
              @click="selectSection({ d: 'yGuide', name: 'Guia' })"
            >
              Resultados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yFiles') }"
              @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
            >
              Anexos
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="is-mobileLider">
      <button
        v-if="select === 'yResultado'"
        class="button is-link"
        :class="showMenu ? 'button-lider-open' : 'button-lider-closed'"
        :style="isOculto ? 'margin-left: 91.5%;' : 'margin-left: 77.7%;'"
        v-on:click="changeMenu"
      >
        <span class="icon"><i class="material-icons">info_outline</i></span>
      </button>
      <transition name="fade">
        <div
          v-if="select === 'yResultado' && showMenu && sectInter !== ''"
          class="button is-link"
          v-tooltip.left="'Volver atrás'"
          style="top: 80px"
          :class="
            sectInter !== '' ? 'button-lider-open' : 'button-lider-closed'
          "
          :style="isOculto ? 'margin-left: 83.5%;' : 'margin-left: 97%;'"
          v-on:click="selectVar('')"
        >
          <span class="icon"><i class="material-icons">arrow_back</i></span>
        </div>
      </transition>
    </div>
    <section
      class="is-fullheight is-fullwidth"
      :class="{ colums: !activo('yGuide') }"
      style="transition: all 0.3s ease 0s !important;"
    >
      <div
        :class="{ 'container colum': !activo('yGuide') }"
        style="transition: all 0.3s ease 0s !important;"
      >
        <div
          :class="{
            container: !activo('yGuide'),
            'container-guie': activo('yGuide'),
          }"
          v-if="tokenUser"
        >
          <component
            ref="content"
            :is="select"
            :proceso="proceso"
            :process="proceso"
            :tokenUser="tokenUser"
            @selproceso="selproceso"
            @selectSection="selectSection"
            @traerelaciones="traerelaciones"
            @calculateProcess="calculateProcess"
          ></component>
        </div>
      </div>
      <div
        :class="
          select === 'yResultado' && showMenu ? 'column is-2' : 'column is-0'
        "
        style="transition: all 0.3s ease 0s !important;"
      >
        <aside
          :class="showMenu ? 'sidebarLider-show' : 'sidebarLider-none'"
          class="is-narrow-mobile is-fullheight section is-hidden-mobile scroll-light"
          style="overflow-y: scroll"
        >
          <p
            class="has-text-centered is-size-4 has-text-weight-bold has-text-dark"
          >
            Interpretaciones {{ sectInter }}
          </p>
          <br />
          <div v-for="(item, k) in calificaciones" :key="k">
            <transition name="fade">
              <div v-if="sectInter === ''">
                <br />
                <div
                  class="tags has-addons"
                  style="cursor: pointer"
                  v-on:click="selectVar(nombres[k])"
                >
                  <span
                    class="tag is-medium is-dark is-flex"
                    style="width: 100%; justify-content: space-between"
                  >
                    <span></span>
                    <span class="text-dots">{{ nombres[k] }}</span>
                    <span class="icon"
                      ><i class="material-icons is-size-1"
                        >arrow_drop_down</i
                      ></span
                    >
                  </span>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div v-if="sectInter === nombres[k]">
                <div v-for="(itVar, kv) in item" :key="kv">
                  <div class="tags has-addons">
                    <span
                      class="tag is-medium"
                      style="width: 100%; height: 100%; white-space: initial; text-align: center"
                      :class="`rango${kv === 0 ? kv : item.length - kv}`"
                    >
                      {{ nombresRangos[kv] }}
                    </span>
                  </div>
                  <div class="text-justify is-size-7">
                    {{ kv === 0 ? itVar : item[item.length - kv] }}
                  </div>
                  <hr />
                </div>
              </div>
            </transition>
          </div>
        </aside>
      </div>
    </section>
  </div>
</template>

<script>
import yResumen from "@/components/lideres/Resumen.vue";
import yProceso from "@/components/lideres/Proceso.vue";
import yEmpleados from "@/components/lideres/Empleados.vue";
import yRelaciones from "@/components/lideres/Relaciones.vue";
import yGuide from "./GuiaInterpretacion.vue";
import yResultado from "@/components/lideres/Resultados.vue";
import yFiles from "@/components/attached/uploadFilesBoard.vue";
import yAjustes from "@/components/lideres/Ajustes/Ajustes.vue";
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";

import json from "./calificacionLider.json";

export default {
  data() {
    return {
      select: "yProceso",
      title: "Proceso",
      calificaciones: json.calificaciones,
      nombresRangos: [
        "Sin Resultados",
        "Líder PHD",
        "Líder experta(o)",
        "Líder competente",
        "Líder en desarrollo",
        "Líder con oportunidad de mejora",
        "Líder con prioridad de intervención",
      ],
      nombres: {
        general: "General",
        cond: "Gestión del Conocimiento",
        resuld: "Gestión de Resultados",
        cambiod: "Cambio y Toma de Decisiones",
        logrod: "Logro",
        dsmd: "Gestión de Sí Mismo",
        humid: "Humildad",
        autogd: "Autogestión",
        gperd: "Gestión de Personas",
        reld: "Gestión de Relaciones",
        cefectivad: "Comunicación Efectiva",
        asertivad: "Asertividad",
        cercaniad: "Cercanía",
        rad: "Retroalimentación",
        liderT: "Líder PHD",
      },
      sectInter: "",
      showMenu: false,
      showMenuMobile: false,
      proceso: {
        nombre: ".....",
      },
      relaciones: [],
    };
  },
  computed: {
    ...mapState(["tokenUser", "isOculto", "isMovil", "empresa"]),
  },
  methods: {
    selproceso(d, p) {
      this.proceso = d;
      if (Object.keys(p).length > 0) {
        this.proceso.processComp = p;
      }
      setTimeout(
        this.selectSection({ d: "yEmpleados", name: "Empleados" }),
        5000
      );
    },
    selectSection({ d, name }) {
      if (this.proceso.nombre !== ".....") {
        if (d === "yEmpleados") {
          this.select = d;
          this.title = name;
          this.traerelaciones();
        } else if (d === "yResultado") {
          let terminado = this.relaciones.filter(
            (r) => r["status"] === "calculado"
          ).length;
          if (terminado > 3) {
            this.select = d;
            this.title = name;
          } else {
            this.$store.dispatch("notify", {
              message: `Los colaboradores no han respondido lo suficiente`,
              type: "is-danger",
            });
          }
        } else {
          console.log(d);

          this.select = d;
          this.title = name;
        }
        this.closeMenuMobile();
      } else {
        this.$store.dispatch("notify", {
          message: `Selecciona un proceso`,
          type: "is-danger",
        });
        this.closeMenuMobile();
      }
    },
    selectVar(group) {
      if (this.sectInter === group) {
        this.sectInter = "";
      } else {
        this.sectInter = group;
      }
    },
    activo(a) {
      if (a === this.select) {
        return true;
      } else {
        return false;
      }
    },
    async traerelaciones() {
      this.relaciones = [];
      let result;
      try {
        result = await apiServices.get(
          `/listliderrelacion/${this.proceso._id}`
        );
        if (result.data) {
          this.relaciones = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeMenu() {
      this.showMenu ? (this.showMenu = false) : (this.showMenu = true);
    },
    closeMenuMobile() {
      this.showMenuMobile = false;
    },
    async calculateProcess() {
      let result;
      const d = {
        id: this.proceso._id,
      };
      try {
        result = await apiServices.post(`/calcular`, d);

        if (result.data !== "Sin datos para calcular") {
          await this.traerelaciones();
          await this.$emit("traerelaciones");
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    isOculto(nv) {
      if (!nv) {
        this.showMenu = false;
      }
    },
    select(nv) {
      if (nv !== "yResultado") {
        this.showMenu = false;
      }
    },
    showMenu(nv) {
      if (nv && !this.isOculto) {
        this.$store.commit("ocultarSide");
      }
    },
  },
  components: {
    yResumen,
    yProceso,
    yEmpleados,
    yRelaciones,
    yGuide,
    yResultado,
    yFiles,
    yAjustes,
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  width: 100%;
  position: absolute;
  z-index: 1;
}

.contenedor2 {
  width: 90%;
  position: absolute;
  z-index: 1;
}

.container-guie {
  margin-top: 10px;
}

a.dropdown-item.is-active,
button.dropdown-item.is-active {
  background-color: #522687;
  color: #fff;
}

.tabs.is-toggle li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.hero.is-grey-ligth .tabs.is-boxed li.is-active a {
  background-color: white;
  border: solid 0 white;
  color: #522687 !important;
  box-shadow: #00000029 0px 14px 20px;
}

.hero.is-grey-ligth .tabs.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.hero.is-grey-ligth {
  padding-left: 40px;
}

.hero.is-grey-ligth .tabs.is-boxed a {
  border: 0px solid transparent;
  border-radius: 4px 4px 0 0;
}

.text-card {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: white;
}

.sidebarLider-show {
  z-index: 60;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: 0;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.sidebarLider-none {
  z-index: 0;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: -300px;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.button-lider-closed {
  position: fixed;
  top: 20px;
  padding: 15px;
  margin-left: 97%;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-lider-open {
  position: fixed;
  top: 20px;
  padding: 15px;
  margin-left: 79% !important;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.text-dots {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.rango1 {
  background-color: #f4cdcd !important;
  color: white;
}

.rango2 {
  background-color: #facca5 !important;
  color: white;
}

.rango3 {
  background-color: #fff2cc !important;
  color: white;
}

.rango4 {
  background-color: #d9ead3 !important;
  color: white;
}

.rango5 {
  background-color: #a2c4c9 !important;
  color: white;
}

.rango6 {
  background-color: #c8d9f7 !important;
  color: white;
  /* color: rgba(65, 64, 64, 0.91); */
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.81);
  color: white;
}

.text-justify {
  text-align: left !important;
  text-justify: inter-word !important;
}

.is-mobileLider {
  @media (max-width: 769px) {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Liderv1.vue